import { WCheckbox } from './checkbox';
if (!customElements.get('w-checkbox')) {
    customElements.define('w-checkbox', WCheckbox);
}
//# sourceMappingURL=index.js.map